import { BoxProps, TextProps } from '@chakra-ui/react';

type AvatarColors = {
  bg: BoxProps['bg'];
  color: TextProps['color'];
};

const AVATAR_COLOR_PALETTE: AvatarColors[] = [
  { bg: 'tag.background.green', color: 'tag.text.green' },
  { bg: 'tag.background.blue', color: 'tag.text.blue' },
  { bg: 'tag.background.yellow', color: 'tag.text.yellow' },
  { bg: 'tag.background.purple', color: 'tag.text.purple' },
  { bg: 'tag.background.skyBlue', color: 'tag.text.skyBlue' },
];

export const getAvatarColorsFromName = (name: string): AvatarColors => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLOR_PALETTE[Math.abs(hash) % AVATAR_COLOR_PALETTE.length];
};
